<template>
              <div  class='book_cover'>
                <span class="book_name">{{ itemChild.bookName }}</span>
              <div :class="itemChild.bookName.length>10?'name_minHeight':'name_height'">
                <p class="single-brief" :style="{'-webkit-line-clamp':itemChild.bookName.length>10?'5':'6'}">{{ itemChild.bookSummary }}</p>
              </div>
           
           <div class="single-bottom">
            <span class="sort" v-if="itemChild.category">{{
            itemChild.category.split(",")[0]
          }}</span>
          <span class="single-title-right"
            >{{ itemChild.studyingVolume }}万热度</span
          >
        </div>
                </div>
</template>

<script>
import {Toast, MessageBox } from "mint-ui";
	export default {
		name: 'three_conpontent',
		props: {
            itemChild:{
				type: Object,
				default: {
                }
            }
		},
		data() {
			return {
			};
		},
		watch: {
			// current(val) {
			// 	if (val !== this.currentIndex) {
			// 		this.currentIndex = val;
			// 	}
			// }
		},
		methods: {
			
		},
		created() {
		}
	};
</script>

<style  scoped>
.name_height{
  height:120px;
}
.name_minHeight{
  height:100px;
}
.book_cover{
  width: 156px;
  height: 215px;
  border-radius: 4px;
  margin-bottom:20px;
  padding:16px 8px;
  box-sizing: border-box;
}
.book_cover:nth-child(4n-3){
  background: #FDFAF6;
}
.book_cover:nth-child(4n-2),.book_cover:nth-child(4n-1){
  background:  #F9FBFF;
}
.book_cover:nth-child(4n){
  background: #FFF9F9;
}
.image_div {
  display: block;
  width: 78px;
  height: 104px;
  border-radius: 6px;
  margin:0 auto;
}
.book_name {
  overflow: hidden;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  font-size: 14px;
color: #333333;
line-height: 20px;
font-weight: 600;
  /* height: 40px; */
}

.single-brief{
  margin-top:10px;
  font-size: 14px;
color: #666666;
  overflow: hidden;
  -webkit-line-clamp: 6;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  width:100%;
}
.single-title-right {
  font-size: 12px;
  color: #de3b34;
}
.sort {
  background-color: rgb(253, 245, 233);
    border-radius: 4px;
    font-size: 12px;
    padding: 0 5px;
    color: #f09b28;
    line-height: 18px;
    display:inline-block;
}
.single-bottom {
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/book_item/ten_compontent.vue